<template>
  <svg width="18" height="18" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.753.729a2.487 2.487 0 1 1 3.518 3.518l-5.907 5.908c-.347.347-.79.583-1.271.68l-2.44.488a.83.83 0 0 1-.976-.976l.488-2.44c.097-.482.333-.924.68-1.27L10.754.728zm2.346 1.172a.83.83 0 0 0-1.174 0l-.314.315 1.173 1.173.315-.314a.83.83 0 0 0 0-1.174zm-1.488 2.66L10.44 3.39l-4.42 4.42a.828.828 0 0 0-.227.423l-.244 1.22 1.22-.244a.828.828 0 0 0 .424-.226l4.42-4.42zM2.488 1.73a.83.83 0 0 0-.83.83v9.952c0 .458.372.83.83.83h9.953a.83.83 0 0 0 .83-.83V7.536a.83.83 0 1 1 1.658 0v4.976A2.488 2.488 0 0 1 12.441 15H2.488A2.488 2.488 0 0 1 0 12.512V2.559A2.488 2.488 0 0 1 2.488.071h4.976a.83.83 0 0 1 0 1.659H2.488z"
      fill="#000" fill-rule="nonzero" />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'GoRateEdit'
})
</script>
